import { useGridApiContext as MUIUseGridApiContext } from '@mui/x-data-grid-premium';

const useGridApiContext = () => {
  const apiRef = MUIUseGridApiContext();
  return apiRef.current;
};

export default useGridApiContext;
